var Ce=Object.create;var te=Object.defineProperty;var Ie=Object.getOwnPropertyDescriptor;var Le=Object.getOwnPropertyNames;var Oe=Object.getPrototypeOf,Pe=Object.prototype.hasOwnProperty;var E=(r,t)=>()=>(t||r((t={exports:{}}).exports,t),t.exports);var De=(r,t,n,o)=>{if(t&&typeof t=="object"||typeof t=="function")for(let s of Le(t))!Pe.call(r,s)&&s!==n&&te(r,s,{get:()=>t[s],enumerable:!(o=Ie(t,s))||o.enumerable});return r};var j=(r,t,n)=>(n=r!=null?Ce(Oe(r)):{},De(t||!r||!r.__esModule?te(n,"default",{value:r,enumerable:!0}):n,r));var k=E(X=>{var ie;(function(r){typeof DO_NOT_EXPORT_CRC>"u"?typeof X=="object"?r(X):typeof define=="function"&&define.amd?define(function(){var t={};return r(t),t}):r(ie={}):r(ie={})})(function(r){r.version="0.3.0";function t(){for(var a=0,e=new Array(256),l=0;l!=256;++l)a=l,a=a&1?-306674912^a>>>1:a>>>1,a=a&1?-306674912^a>>>1:a>>>1,a=a&1?-306674912^a>>>1:a>>>1,a=a&1?-306674912^a>>>1:a>>>1,a=a&1?-306674912^a>>>1:a>>>1,a=a&1?-306674912^a>>>1:a>>>1,a=a&1?-306674912^a>>>1:a>>>1,a=a&1?-306674912^a>>>1:a>>>1,e[l]=a;return typeof Int32Array<"u"?new Int32Array(e):e}var n=t(),o=typeof Buffer<"u";function s(a){if(a.length>32768&&o)return d(new Buffer(a));for(var e=-1,l=a.length-1,f=0;f<l;)e=n[(e^a.charCodeAt(f++))&255]^e>>>8,e=n[(e^a.charCodeAt(f++))&255]^e>>>8;return f===l&&(e=e>>>8^n[(e^a.charCodeAt(f))&255]),e^-1}function i(a){if(a.length>1e4)return d(a);for(var e=-1,l=0,f=a.length-3;l<f;)e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255];for(;l<f+3;)e=e>>>8^n[(e^a[l++])&255];return e^-1}function d(a){for(var e=-1,l=0,f=a.length-7;l<f;)e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255],e=e>>>8^n[(e^a[l++])&255];for(;l<f+7;)e=e>>>8^n[(e^a[l++])&255];return e^-1}function u(a){for(var e=-1,l=0,f=a.length,c,m;l<f;)c=a.charCodeAt(l++),c<128?e=e>>>8^n[(e^c)&255]:c<2048?(e=e>>>8^n[(e^(192|c>>6&31))&255],e=e>>>8^n[(e^(128|c&63))&255]):c>=55296&&c<57344?(c=(c&1023)+64,m=a.charCodeAt(l++)&1023,e=e>>>8^n[(e^(240|c>>8&7))&255],e=e>>>8^n[(e^(128|c>>2&63))&255],e=e>>>8^n[(e^(128|m>>6&15|c&3))&255],e=e>>>8^n[(e^(128|m&63))&255]):(e=e>>>8^n[(e^(224|c>>12&15))&255],e=e>>>8^n[(e^(128|c>>6&63))&255],e=e>>>8^n[(e^(128|c&63))&255]);return e^-1}r.table=n,r.bstr=s,r.buf=i,r.str=u})});var ue=E((st,le)=>{var Ue=k();le.exports=qe;var x=new Uint8Array(4),Be=new Int32Array(x.buffer),Re=new Uint32Array(x.buffer);function qe(r){if(r[0]!==137)throw new Error("Invalid .png file header");if(r[1]!==80)throw new Error("Invalid .png file header");if(r[2]!==78)throw new Error("Invalid .png file header");if(r[3]!==71)throw new Error("Invalid .png file header");if(r[4]!==13)throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");if(r[5]!==10)throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");if(r[6]!==26)throw new Error("Invalid .png file header");if(r[7]!==10)throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");for(var t=!1,n=[],o=8;o<r.length;){x[3]=r[o++],x[2]=r[o++],x[1]=r[o++],x[0]=r[o++];var s=Re[0]+4,i=new Uint8Array(s);i[0]=r[o++],i[1]=r[o++],i[2]=r[o++],i[3]=r[o++];var d=String.fromCharCode(i[0])+String.fromCharCode(i[1])+String.fromCharCode(i[2])+String.fromCharCode(i[3]);if(!n.length&&d!=="IHDR")throw new Error("IHDR header missing");if(d==="IEND"){t=!0,n.push({name:d,data:new Uint8Array(0)});break}for(var u=4;u<s;u++)i[u]=r[o++];x[3]=r[o++],x[2]=r[o++],x[1]=r[o++],x[0]=r[o++];var a=Be[0],e=Ue.buf(i);if(e!==a)throw new Error("CRC values for "+d+" header do not match, PNG file is likely corrupted");var l=new Uint8Array(i.buffer.slice(4));n.push({name:d,data:l})}if(!t)throw new Error(".png file ended prematurely: no IEND header was found");return n}});var ce=E((it,de)=>{de.exports=function(r,t,n){var o=[],s=r.length;if(s===0)return o;var i=t<0?Math.max(0,t+s):t||0;for(n!==void 0&&(s=n<0?n+s:n);s-- >i;)o[s-i]=r[s];return o}});var me=E((lt,fe)=>{var Ge=ce(),Te=k();fe.exports=_e;var y=new Uint8Array(4),Ne=new Int32Array(y.buffer),He=new Uint32Array(y.buffer);function _e(r){var t=8,n=t,o;for(o=0;o<r.length;o++)t+=r[o].data.length,t+=12;var s=new Uint8Array(t);for(s[0]=137,s[1]=80,s[2]=78,s[3]=71,s[4]=13,s[5]=10,s[6]=26,s[7]=10,o=0;o<r.length;o++){var i=r[o],d=i.name,u=i.data,a=u.length,e=[d.charCodeAt(0),d.charCodeAt(1),d.charCodeAt(2),d.charCodeAt(3)];He[0]=a,s[n++]=y[3],s[n++]=y[2],s[n++]=y[1],s[n++]=y[0],s[n++]=e[0],s[n++]=e[1],s[n++]=e[2],s[n++]=e[3];for(var l=0;l<a;)s[n++]=u[l++];var f=e.concat(Ge(u)),c=Te.buf(f);Ne[0]=c,s[n++]=y[3],s[n++]=y[2],s[n++]=y[1],s[n++]=y[0]}return s}});var he=E((ut,pe)=>{pe.exports=Ve;function Ve(r,t){if(r=String(r),t=String(t),!/^[\x00-\xFF]+$/.test(r)||!/^[\x00-\xFF]+$/.test(t))throw new Error("Only Latin-1 characters are permitted in PNG tEXt chunks. You might want to consider base64 encoding and/or zEXt compression");if(r.length>=80)throw new Error('Keyword "'+r+'" is longer than the 79-character limit imposed by the PNG specification');for(var n=r.length+t.length+1,o=new Uint8Array(n),s=0,i,d=0;d<r.length;d++){if(!(i=r.charCodeAt(d)))throw new Error("0x00 character is not permitted in tEXt keywords");o[s++]=i}o[s++]=0;for(var u=0;u<t.length;u++){if(!(i=t.charCodeAt(u)))throw new Error("0x00 character is not permitted in tEXt content");o[s++]=i}return{name:"tEXt",data:o}}});var ve=E((dt,ge)=>{ge.exports=je;function je(r){r.data&&r.name&&(r=r.data);for(var t=!0,n="",o="",s=0;s<r.length;s++){var i=r[s];if(t)i?o+=String.fromCharCode(i):t=!1;else if(i)n+=String.fromCharCode(i);else throw new Error("Invalid NULL character found. 0x00 character is not permitted in tEXt content")}return{keyword:o,text:n}}});var xe=E(Z=>{Z.encode=he();Z.decode=ve()});var re=()=>{if(typeof window>"u"||typeof window.CanvasRenderingContext2D>"u"||!n())return;let r=CanvasRenderingContext2D.prototype,t=r.drawImage;if(!t){console.error("This script requires a basic implementation of drawImage");return}r.drawImage=function(u,a,e){if(!(arguments.length===9))return t.apply(this,[...arguments]);let f=o(...arguments);if(!s(f))return t.apply(this,f)};function n(){let d=document.createElement("canvas").getContext("2d");d.fillRect(0,0,40,40),d.drawImage(d.canvas,-40,-40,80,80,50,50,20,20);let u=d.getImageData(50,50,30,30),a=new Uint32Array(u.data.buffer),e=(c,m)=>a[m*u.width+c],l=[[9,9],[20,9],[9,20],[20,20]],f=[[10,10],[19,10],[10,19],[19,19]];return l.some(([c,m])=>e(c,m)!==0)||f.some(([c,m])=>e(c,m)===0)}function o(d,u,a,e,l,f,c,m,p){let{width:b,height:F}=i(d);e<0&&(u+=e,e=Math.abs(e)),l<0&&(a+=l,l=Math.abs(l)),m<0&&(f+=m,m=Math.abs(m)),p<0&&(c+=p,p=Math.abs(p));let g=Math.max(u,0),M=Math.min(u+e,b),v=Math.max(a,0),h=Math.min(a+l,F),A=m/e,w=p/l;return[d,g,v,M-g,h-v,u<0?f-u*A:f,a<0?c-a*w:c,(M-g)*A,(h-v)*w]}function s(d){return[3,4,7,8].some(u=>!d[u])}function i(d){let u=a=>{let e=globalThis[a];return e&&d instanceof e};if(u("HTMLImageElement"))return{width:d.naturalWidth,height:d.naturalHeight};if(u("HTMLVideoElement"))return{width:d.videoWidth,height:d.videoHeight};if(u("SVGImageElement"))throw new TypeError("SVGImageElement isn't yet supported as source image.","UnsupportedError");if(u("HTMLCanvasElement")||u("ImageBitmap"))return d}};var ne="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";function ae(r){return r.split("").reduce((t,n)=>t*64+ne.indexOf(n),0)}function oe(r){let t=ne.split(""),n=[],o=0;for(let s of r)n[o++]=t.indexOf(s)/64;return n}function se(r){return r&&typeof r=="string"&&r.length===87&&r.split(".").length===2}function U(r){let t=r.split("."),n=t.map(u=>oe(u)),o=n.map(u=>u[42]),s=n.map(u=>u.reduce((a,e)=>a+e)/u.length),i=t.map(u=>ae(u)%360),d=t.map((u,a)=>`hsl(${i[a]} ${o[a]*100}% ${s[a]*100}%)`);return{finals:o,decoded:n,angles:i,averages:s,colors:d}}function S(r,t=3){return[...Array(Math.ceil(r.length/t))].map(()=>r.splice(0,t))}var J=j(ue(),1),ye=j(me(),1),Y=j(xe(),1);import{ref as Xe}from"vue";var $=Xe(null);function be(r,t,n="png"){if(n==="svg"){let o=r.outerHTML||r;return K(o,t)}else return Je(r,t)}function ke(r){try{let t=r.toDataURL("image/png").split(",")[1],n=atob(t),o=new Uint8Array(n.length);for(let s=0;s<n.length;s++)o[s]=n.charCodeAt(s);return o}catch(t){return $.value="Failed to convert canvas to buffer: "+t.message,null}}function K(r,t){try{let n=`<metadata>
      <gun-data>${JSON.stringify(t)}</gun-data>
    </metadata>`;return r.replace("</svg>",`${n}</svg>`)}catch(n){return $.value="Failed to embed data in SVG: "+n.message,null}}function Ze(r){console.log(r);try{let t=r.match(/<metadata>\s*<gun-data>(.*?)<\/gun-data>\s*<\/metadata>/s);return!t||!t[1]?($.value="No embedded data found in SVG",null):JSON.parse(t[1])}catch(t){return $.value="Failed to extract data from SVG: "+t.message,null}}function Je(r,t){try{let n=ke(r);if(!n)return null;let o=(0,J.default)(n);return o.splice(-1,0,Y.default.encode("message",JSON.stringify(t))),(0,ye.default)(o)}catch(n){return $.value="Failed to embed data: "+n.message,null}}function Ye(r,t="image/png"){if(t==="image/svg+xml"){let n=new TextDecoder().decode(r);return Ze(n)}try{let s=(0,J.default)(r).filter(i=>i.name==="tEXt").map(i=>Y.default.decode(i.data)).find(i=>i.keyword==="message");return s?JSON.parse(s.text):null}catch(n){return $.value=n.message,null}}async function Ke(r){try{if(!(r instanceof File))throw new Error("Input must be a File object");let t=await r.arrayBuffer(),n=new Uint8Array(t);return await Ye(n,r.type)}catch(t){return $.value=t.message,null}}function Ae({pub:r,size:t,dark:n,draw:o,reflect:s,round:i,embed:d,p3:u}){let a=document.createElement("canvas");a.width=a.height=t;let e=a.getContext("2d"),{decoded:l,finals:f}=U(r);if(We({ctx:e,top:f[0],bottom:f[1],size:t,dark:n}),o=="squares"?(e.filter="blur(20px)",we(l[0],e,t,u),e.filter="blur(0px)",e.globalCompositeOperation="color-burn",we(l[1],e,t,u)):($e(l[0],e,t,.42*t,u),e.globalCompositeOperation="multiply",$e(l[1],e,t,.125*t,u)),s&&(e.globalCompositeOperation="source-over",e.scale(-1,1),e.translate(-t/2,0),e.drawImage(a,t/2,0,t,t,0,0,t,t),e.setTransform(1,0,0,1,0,0)),i){let m=e.getImageData(0,0,t,t);e.clearRect(0,0,t,t),e.fillStyle=n?"#cccccc":"#ffffff",e.fillRect(0,0,t,t),e.putImageData(m,0,0),e.globalCompositeOperation="destination-in",e.beginPath(),e.arc(t/2,t/2,t/2,0,Math.PI*2),e.closePath(),e.fill()}let c=a.toDataURL("image/png");if(d){let p=be(a,{pub:r,content:d});if(p){let b=new Blob([p],{type:"image/png"});c=URL.createObjectURL(b)}}return c}function We({ctx:r,top:t=0,bottom:n=150,size:o=200,dark:s=!1}){let i=r.createLinearGradient(0,0,0,o),d=s?0:70;i.addColorStop(0,`hsl(0,0%,${d+t*30}%)`),i.addColorStop(1,`hsl(0,0%,${d+n*30}%)`),r.fillStyle=i,r.fillRect(0,0,o,o)}function we(r,t,n,o){S(r,14).forEach(s=>{if(s.length===14){let[i,d,u,a,e,l,f,c,m,p,b,F,g,M]=s,v=n/8+u*n*(7/8),h=t.createLinearGradient(i*n+v*c,0,i*n+v*g,n);h.addColorStop(0,o?`color(display-p3 ${a} ${e} ${l} / ${f})`:`rgba(${a*255}, ${e*255}, ${l*255}, ${f})`),h.addColorStop(1,o?`color(display-p3 ${m} ${p} ${b} / ${F})`:`rgba(${m*255}, ${p*255}, ${b*255}, ${F})`),t.fillStyle=h,t.translate(i*n,d*n),t.rotate(M*Math.PI),t.fillRect(-v/2,-v/2,v,v),t.setTransform(1,0,0,1,0,0)}})}function $e(r,t,n,o,s){S(r,7).forEach(i=>{if(i.length===7){let[d,u,a,e,l,f,c]=i;t.beginPath(),t.arc(n/2+d*n/2,u*n,a*o,0,2*Math.PI),t.fillStyle=s?`color(display-p3 ${e} ${l} ${f} / ${c})`:`rgba(${e*255}, ${l*255}, ${f*255}, ${c})`,t.closePath(),t.fill()}})}function Ee({size:r,reflect:t,finals:n,averages:o,breathVert:s=.03}={}){return`
    <script type="text/javascript"><![CDATA[
      // Compact state using shorter variable names
      const s = {
        e: [], // elements
        m: { x: null, y: null, tx: 0, ty: 0 }, // mouse
        r: null, // rect
        f: null, // frame
        t: 0, // lastTime
        p: false, // pulse active
        pt: 0, // pulse start time
        pv: 0  // pulse current value (0-1)
      };

      // Optimize by precomputing constants
      const c = {
        d: 900, // duration
        pr: ${r} * (0.5 + (${n[0]}) / 4), // perspectiveRange
        pz: ${r} * 1.2, // perspectiveZ
        bz: ${r} * 0.4* ${n[1]}, // baseZ
        cx: ${r}/2, // centerX
        cy: ${r}/2, // centerY
        sz: ${r}, // size
        mv: (0.1 + 0.05*${o[0]})* Math.max(0.8, Math.min(4.4, 200/${r})), // movement range for the mouse following
        // Small sizes get slightly stronger animations to be noticeable
        bs: 0.1 * Math.max(0.8, Math.min(1.4, 200/${r})), // breathing scale - stronger for small sizes
        bd: 4500 + ${o[1]}*1000, // breathing duration in ms
        pa: 0.6 * Math.max(0.8, Math.min(1.4, 200/${r})), // pulse amplitude - stronger for small sizes
        pr: 200, // pulse rise time in ms
        pf: 700, // pulse fall time in ms
        bv: ${s} * Math.max(0.8, Math.min(1.4, 200/${r})) // breathing vertical amplitude
      };

      // Init function using IIFE
      (() => {
        const svg = document.currentScript.closest('svg');
        if (!svg) return;
        
        const ur = () => s.r = svg.getBoundingClientRect();
        ur(); // Initial calculation
        
        // Create handler functions once to avoid repeated function creation
        const resizeHandler = ur;
        const mouseHandler = e => {
          const { left, top, width, height } = s.r;
          s.m.tx = ((e.clientX - left) / width) * c.sz;
          s.m.ty = ((e.clientY - top) / height) * c.sz;
          if (s.m.x === null) {
            s.m.x = s.m.tx;
            s.m.y = s.m.ty;
          }
        };
        
        // Pulse start handler for mousedown/touchstart
        const pulseStart = e => {
          s.p = true;
          s.pt = performance.now();
          // Don't prevent default on mousedown to maintain normal behavior
          if (e.type === 'touchstart') e.preventDefault();
        };
        
        // Pulse end handler for mouseup/touchend
        const pulseEnd = () => {
          s.p = false;
          s.pt = performance.now(); // Reset pulse time to track decay
        };
        
        // Pointer leave handler
        const pointerLeave = () => {
          s.m.x = null;
          s.p = false; // Also end pulse if pointer leaves
        };

        // Cache element arrays to avoid repopulation
        s.e = [
          ...Array.from(svg.querySelectorAll('.interactive-circle')).map(el => {
            const x = +el.getAttribute('data-cx'),
                  y = +el.getAttribute('data-cy'),
                  r = +el.getAttribute('r'),
                  o = +el.getAttribute('data-opacity');
            return { 
              el, t: 'c', 
              x, y, r,
              cx: x, cy: y, 
              m: Math.pow(r / (c.sz * 0.05), 0.7) * o, // Mass proportional to radius cubed for realistic feel
              o: Math.random() * Math.PI * 2 // Phase offset
            };
          }),
          ...Array.from(svg.querySelectorAll('.interactive-square')).map(el => {
            const x = +el.getAttribute('data-cx'),
                  y = +el.getAttribute('data-cy'),
                  r = +el.getAttribute('data-r'),
                  o = +el.getAttribute('data-opacity'),
                  a = +el.getAttribute('data-angle') + (Math.random() * 20 - 10);
            return { 
              el, t: 's', 
              x, y, z: c.bz, r: a, 
              cx: x, cy: y, cz: c.bz, cr: a, cs: 1,
              m: Math.pow((r / c.sz), 1.5) * o, // Mass proportional to size for realistic feel
              o: Math.random() * Math.PI * 2 // Phase offset
            };
          })
        ];

        // Initial transform for squares
        s.e.filter(el => el.t === 's').forEach(setTransform);

        // Event listeners - reuse handler functions
        window.addEventListener('resize', resizeHandler, { passive: true });
        svg.addEventListener('mousemove', mouseHandler, { passive: true });
        svg.addEventListener('mouseenter', mouseHandler, { passive: true });
        svg.addEventListener('mouseleave', pointerLeave, { passive: true });
        
        // Pulse events
        svg.addEventListener('mousedown', pulseStart, { passive: true });
        svg.addEventListener('touchstart', pulseStart, { passive: false });
        window.addEventListener('mouseup', pulseEnd, { passive: true });
        window.addEventListener('touchend', pulseEnd, { passive: true });
        window.addEventListener('touchcancel', pulseEnd, { passive: true });
        
        // Start animation
        animate(performance.now());
        
        // Cleanup function for event listener removal
        document.currentScript.addEventListener('remove', () => {
          cancelAnimationFrame(s.f);
          window.removeEventListener('resize', resizeHandler);
          svg.removeEventListener('mousemove', mouseHandler);
          svg.removeEventListener('mouseenter', mouseHandler);
          svg.removeEventListener('mouseleave', pointerLeave);
          svg.removeEventListener('mousedown', pulseStart);
          svg.removeEventListener('touchstart', pulseStart);
          window.removeEventListener('mouseup', pulseEnd);
          window.removeEventListener('touchend', pulseEnd);
          window.removeEventListener('touchcancel', pulseEnd);
        });
      })();

      // Transform function - kept out of loop for clarity
      function setTransform(el) {
        const ps = c.pz / (c.pz + el.cz);
        const px = c.cx + (el.cx - c.cx) * ps;
        const py = c.cy + (el.cy - c.cy) * ps;
        el.el.setAttribute('transform',
          'translate('+ px+' '+ py+') rotate('+ el.cr+ ') scale(' +  ps * el.cs+')'
        );
      }
      
      // Update pulse value with smooth interpolation
      function updatePulseValue(time) {
        if (s.p) {
          // Smooth rise when pressed
          const elapsed = time - s.pt;
          s.pv += (1 - s.pv) * Math.min(1, elapsed / c.pr);
        } else {
          // Smooth fall when released
          const elapsed = time - s.pt;
          s.pv *= Math.max(0, 1 - elapsed / c.pf);
        }
        return s.pv;
      }
      
      // Calculate breathing and pulse together
      function getEffects(el, time, pulseValue) {
        // Calculate breathing cycle (0-2\u03C0)
        const angle = (time % c.bd) / c.bd * Math.PI * 2 + el.o;
        
        // Calculate sin wave (-1 to 1)
        const wave = Math.sin(angle);
        
        // Scale and offset
        const breathScale = 1 + wave * c.bs * (1 - Math.min(0.8, el.m));
        const yOffset = wave * c.sz * c.bv * (1 - Math.min(0.8, el.m));
        
        // Apply mass-proportional pulse (smaller objects pulse more)
        // Use inverse square law: smaller objects get more effect
        // Stronger effect for very small objects
        const massEffect = Math.pow(1 - Math.min(0.8, el.m), 2);
        const pulse = pulseValue * c.pa * massEffect;
        
        return { 
          scale: breathScale * (1 + pulse),
          yOffset,
          pulse
        };
      }

      // Update elements efficiently
      function updateElement(el, dt, time, pulseValue) {
        const sm = Math.min(dt / c.d, 1) * (el.t === 's' ? 0.3 : 0.1);
        const fx = getEffects(el, time, pulseValue);
        const mouseStrength = Math.max(0.6, Math.min(1, c.sz / 150));
        
        if (el.t === 'c') { // Circle update
          if (s.m.x !== null) {
            const dx = s.m.x - el.x;
            const dy = s.m.y - el.y;
            const d = Math.sqrt(dx * dx + dy * dy); // Faster than hypot for 2D
            
            // Size-relative movement radius
            const moveMax = c.sz * c.mv * (1 - Math.min(0.8, el.m));
            const move = Math.min(d, moveMax) * mouseStrength;
            
            // Only calculate angle if needed
            const a = d > 0.1 ? Math.atan2(dy, dx) : 0;
            
            // Target with breathing + mouse
            const tx = el.x + move * (dx / d);
            const ty = el.y + move * (dy / d) + fx.yOffset;
            
            el.cx += (tx - el.cx) * 0.1;
            el.cy += (ty - el.cy) * 0.1;
          } else {
            // Only breathing when no mouse
            el.cx += (el.x - el.cx) * 0.1;
            el.cy += (el.y + fx.yOffset - el.cy) * 0.1;
          }
          
          // Apply attributes
          el.el.setAttribute('cx', el.cx);
          el.el.setAttribute('cy', el.cy);
          el.el.setAttribute('r', el.r * fx.scale);
          
          // Handle reflection if enabled (minimized property lookups)
          if (${t}) {
            const mirror = el.el.nextElementSibling;
            if (mirror) {
              mirror.setAttribute('cx', c.sz - el.cx);
              mirror.setAttribute('cy', el.cy);
              mirror.setAttribute('r', el.r * fx.scale);
            }
          }
          return;
        }

        if (el.t === 's') { // Square update
          if (s.m.x !== null) {
            const dx = s.m.x - el.x;
            const dy = s.m.y - el.y;
            const d = Math.sqrt(dx * dx + dy * dy);
            const n = Math.min(d / c.pr, 1);
            
            // Size-relative movement radius
            const moveMax = c.sz * 0.1 * (1 - Math.min(0.8, el.m));
            const move = Math.min(d, moveMax) * mouseStrength;
            
            // Only calculate angle if needed
            const a = d > 0.1 ? Math.atan2(dy, dx) : 0;
            
            // Fast power for smoother effect
            const zf = 1 - n * n;
            
            // Update with mouse + breathing
            el.cx += (el.x + move * (dx / d) - el.cx) * sm;
            el.cy += (el.y + move * (dy / d) + fx.yOffset - el.cy) * sm;
            
            // Z-depth with pulse
            const depth = c.bz - (c.bz * zf * (1 - Math.min(0.8, el.m)) * fx.scale);
            // Pulse brings forward (squares float forward on click)
            const pulseZ = depth - fx.pulse * c.bz * 0.7;
            el.cz += (pulseZ - el.cz) * sm;
            
            el.cr += (el.r + Math.sin(d / 100) * 5 * (1 - Math.min(0.8, el.m)) - el.cr) * sm;
            el.cs += ((1 + (zf * 0.3 * (1 - Math.min(0.8, el.m)))) * fx.scale - el.cs) * sm;
          } else {
            // Only breathing when no mouse
            el.cx += (el.x - el.cx) * sm;
            el.cy += (el.y + fx.yOffset - el.cy) * sm;
            
            // Z pulse pushes element forward
            const pulseZ = c.bz * (1 - fx.pulse * 0.7);
            el.cz += (pulseZ - el.cz) * sm;
            
            el.cr += (el.r + Math.sin(time / 1500) * 3 * (1 - Math.min(0.8, el.m)) - el.cr) * sm;
            el.cs += (fx.scale - el.cs) * sm;
          }

          setTransform(el);
        }
      }

      // Main animation loop
      function animate(time) {
        const dt = s.t ? time - s.t : 0;
        s.t = time;

        // Mouse smoothing
        if (s.m.x !== null) {
          s.m.x += (s.m.tx - s.m.x) * 0.1;
          s.m.y += (s.m.ty - s.m.y) * 0.1;
        }
        
        // Update pulse value with smooth transitions
        const pulseValue = updatePulseValue(time);

        // Update all elements once
        s.e.forEach(el => updateElement(el, dt, time, pulseValue));
        
        // Continue animation
        s.f = requestAnimationFrame(animate);
      }
    ]]></script>
  `}function Fe({pub:r,size:t=200,dark:n=!1,draw:o="circles",reflect:s=!0,round:i=!0,embed:d=!0,svg:u}={}){let{decoded:a,finals:e,averages:l}=U(r),f=n?"#333":"#eee",c=`
      <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="hsla(0,0%,${(n?0:70)+e[0]*30}%)"/>
        <stop offset="100%" stop-color="hsla(0,0%,${(n?0:70)+e[1]*30}%)"/>
      </linearGradient>
    `,m=(h,A=!1)=>S(h,14).map(w=>{if(w.length!==14)return"";let[C,R,H,_,q,G,I,L,O,P,T,V,Se,W]=w,D=t/8+H*t*(7/8),Q=`gradient-${C}-${R}-${A?"2":"1"}`,z=C*t,ee=R*t,Me=u==="interactive"?`class="interactive-square" data-cx="${z}" data-cy="${ee}" data-r="${D}" data-angle="${W*180}" data-opacity="${(I+V)/2}"`:"";return`
          <defs>
            <linearGradient id="${Q}" x1="${L}" y1="0" x2="${Se}" y2="1">
              <stop offset="0%" stop-color="color(display-p3 ${_} ${q} ${G} / ${I})"/>
              <stop offset="100%" stop-color="color(display-p3 ${O} ${P} ${T} / ${V})"/>
            </linearGradient>
          </defs>
          <g ${Me} transform="translate(${z} ${ee}) rotate(${W*180})">
            <rect 
              x="${-D/2}" y="${-D/2}" 
              width="${D}" height="${D}"
              fill="url(#${Q})"
              style="${A?"mix-blend-mode:color-burn;":"filter:blur(20px);"}"
            />
          </g>
        `}).join(""),p=(h,A,w=!1)=>S(h,7).map(C=>{if(C.length!==7)return"";let[R,H,_,q,G,I,L]=C,O=t/2+R*t/2,P=H*t,T=_*A;return`
          <circle 
            ${u==="interactive"?`class="interactive-circle" data-cx="${O}" data-cy="${P}" data-opacity="${L}"`:""}
            cx="${O}" cy="${P}" r="${T}"
            fill="color(display-p3 ${q} ${G} ${I} / ${L})"

            style="${w?"mix-blend-mode:multiply;":""}"
          />
          ${s?`
          <circle 
            cx="${t-O}" cy="${P}" r="${T}"
            fill="color(display-p3 ${q} ${G} ${I} / ${L})"

            style="${w?"mix-blend-mode:multiply;":""}"
          />`:""}
        `}).join(""),b=i?`
      <defs>
        <clipPath id="circle-mask">
          <circle cx="${t/2}" cy="${t/2}" r="${t/2}" />
        </clipPath>
      </defs>
    `:"",F=u==="interactive"?Ee({size:t,reflect:s,finals:e,averages:l}):"",g=`
      <svg 
        width="${t}" height="${t}" 
        viewBox="0 0 ${t} ${t}" 
        xmlns="http://www.w3.org/2000/svg"
        style="overflow: visible;"
        >
        <defs>${c}</defs>
        ${b}
        <g ${i?'clip-path="url(#circle-mask)"':""}>
          <rect x="${-t}" width="${3*t}" y="${-t}" height="${3*t}" fill="url(#bg)"/>
          ${o==="squares"?`${m(a[0],!1)}
             ${m(a[1],!0)}`:`${p(a[0],.42*t)}
             ${p(a[1],.125*t,!0)}`}
        </g>
        ${F}
      </svg>
    `;if(u==="interactive")return`data:image/svg+xml,${encodeURIComponent(g.trim())}`;if(d){let h={pub:r};d&&(h.content=d),g=K(g,h)}return`data:image/svg+xml;base64,${typeof btoa=="function"?btoa(g):Buffer.from(g).toString("base64")}`}var B={};function N(r={}){let{pub:t,size:n=200,dark:o=!1,draw:s="circles",reflect:i=!0,round:d=!0,embed:u=!0,svg:a=!0,p3:e=!0}=r,l=typeof window<"u"&&typeof document<"u";if(!se(t))return"";if(a||!l)return Fe({pub:t,size:n,dark:o,draw:s,reflect:i,round:d,embed:u,svg:a,p3:e});let f=JSON.stringify(arguments[0]);if(B!=null&&B[f])return B[f];let c=Ae({pub:t,size:n,dark:o,draw:s,reflect:i,round:d,embed:u,svg:a,p3:e});return B[f]=c,c}function Qe(r="gun-avatar"){document.addEventListener("DOMContentLoaded",()=>{let t=document.getElementsByClassName(r);for(let n in t){let o=t[n];o.dataset.round!=="false"&&(o.style.borderRadius="100%");let s=o.dataset.embed;if(o.dataset.embed!=="true")try{s=JSON.parse(o.dataset.embed)}catch{console.warn("Invalid content JSON in data-embed attribute")}o.src=N({pub:o.dataset.pub,size:Number(o.dataset.size),dark:!!o.dataset.dark,draw:o.dataset.draw,reflect:o.dataset.reflect!=="false",svg:o.dataset.svg,round:!!o.dataset.round,embed:s==="false"?!1:s||!0})}})}function ze(r="gun-avatar"){let t=!1;if(t)return;class n extends HTMLElement{constructor(){super(),this.attachShadow({mode:"open"}),this.img=document.createElement("img"),this.shadowRoot.append(this.img)}render(){this.pub=this.getAttribute("pub")||"1234123455Ute2tFhdjDQgzR-1234lfSlZxgEZKuquI.2F-j1234434U1234Asj-5lxnECG5TDyuPD8gEiuI123",this.size=this.hasAttribute("size")?Number(this.getAttribute("size")):400,this.draw=this.getAttribute("draw")||"circles",this.reflect=this.hasAttribute("reflect")?this.getAttribute("reflect")!=="false":!0,this.round=this.hasAttribute("round")||this.getAttribute("round")==="",this.dark=this.hasAttribute("dark")?this.getAttribute("dark")!="":!1,this.embed=this.hasAttribute("embed")?this.getAttribute("embed")!=="false":!0,this.svg=this.hasAttribute("dark")&&this.getAttribute("dark"),this.p3=this.hasAttribute("p3")?this.getAttribute("p3")!=="false":!0;let s=this.getAttribute("embed");if(this.getAttribute("embed"))try{s=JSON.parse(this.getAttribute("embed"))}catch{console.warn("Invalid content JSON in embed attribute")}this.img.style.borderRadius=this.round?"100%":"0%",this.img.src=N({pub:this.pub,size:this.size,dark:this.dark,draw:this.draw,reflect:this.reflect,round:this.round,svg:this.svg,embed:s==="false"?!1:s||!0,p3:this.p3})}connectedCallback(){this.render()}static get observedAttributes(){return["pub","round","size","dark","draw","reflect","embed","p3"]}attributeChangedCallback(){this.render()}}customElements.define(r,n),t=!0}re();export{$ as error,Ke as extractFromFile,N as gunAvatar,Qe as mountClass,ze as mountElement,U as parsePub};
//# sourceMappingURL=index.js.map